<template>
    <!-- <div class="tag">
        <h3>{{t("about.brand")}}</h3>
        <p>{{t('about.m-2018-b1')}}</p>
        <img :src="`${imageUrl2}logo-sub-brand-dp-colour-light-bg@2x.png`" class="dooprime"/>
    </div> -->
    <div class="tag">
        <h3>{{ t("about.global") }}</h3>
        <p>{{t('about.m-2018-g1')}}</p>
        <p>{{t('about.m-2018-g2')}}</p>
    </div>
    <div class="tag">
        <h3>{{t("about.safety")}}</h3>
        <p>{{t('about.m-2018-s1')}}</p>
    </div>
    <!--div class="tag">
        <h3>{{ t("about.product") }}</h3>
        <p>{{t('about.m-2018-p1')}}</p>
        <p>{{t('about.m-2018-p2')}}</p>
    </div-->
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const imageUrl2 = "https://doo-prime-static.oss-cn-hongkong.aliyuncs.com/doo/about/";

const { t } = useI18n();
</script>
